import { render, staticRenderFns } from "./BlockListVisualShortcutsCustom.vue?vue&type=template&id=3f84dc5a&"
import script from "./BlockListVisualShortcutsCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListVisualShortcutsCustom.vue?vue&type=script&lang=js&"
import style0 from "./BlockListVisualShortcutsCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports